import { ModalTypes } from 'enums/modalTypes';
import { openModal } from 'graphql/modals';
import { FC } from 'react';
import { Button } from '@spotted-zebra-uk/ui-components';

interface IIndirectInvitationButton {
  projectId: number;
  stageId: string;
  disabled: boolean;
}

const IndirectInvitationButton: FC<IIndirectInvitationButton> = ({
  projectId,
  stageId,
  disabled,
}) => {
  const handleIndirectInvitationButtonClick = () => {
    openModal(ModalTypes.STAGE_INDIRECT_INVITATION_MODAL, {
      projectId,
      stageId,
    });
  };

  return (
    <Button
      onClick={handleIndirectInvitationButtonClick}
      size="small"
      variant="tertiary"
      disabled={disabled}
    >
      Share assessment via link
    </Button>
  );
};

export default IndirectInvitationButton;
